export enum savingsType {
  id = 'savings',
  label = 'Poupança',
}

export enum newSavingsType {
  id = 'new-savings',
  label = 'Poupança Nova',
}

export enum newSavingsWithSelicType {
  id = 'new-savings-with-selic',
  label = 'Juros poupança nova',
}
